var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"signUp"}},[_c('f7-navbar',{attrs:{"back-link":"Back"}},[_c('f7-nav-title',[_vm._v("Sign Up")])],1),_vm._v(" "),_c('Register',{on:{"showSignIn":_vm.goToSignIn,"sign-up":_vm.signUp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }